import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/ActionTypes";
import Toast from "../../components/shared/Toast";

const CONTEST_LIST_URL = "/framework/api/CHLIRnR/contest-list";
const FETCH_CONTEST_URL = "/framework/api/CHLIRnR/fetch-contest";
const COPY_CONTEST_URL = "/framework/api/CHLIRnR/copy-contest";
const DELETE_CONTEST_URL = "/framework/api/CHLIRnR/delete-contest";
const PAUSE_CONTEST_URL = "/framework/api/CHLIRnR/pause-contest";
const CREATE_CONTEST_URL = "/framework/api/CHLIRnR/create-contest";
const UPDATE_CONTEST_URL = "/framework/api/CHLIRnR/update-contest";

// SET Unauthorization Status
export const setUnauthorizedContest = () => {
  return (dispatch) => {
    dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: null });
  };
};

// Fetch Contest List
export const fetchContestList = (authToken, search = "", page = 1, limit = 20, status = "", contest_type = "", fromdate = "", todate = "", sort_type = "", sort = "") => {
  return async (dispatch) => {
    dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: true });
    try {
      const payload = {
        search: search,
        page: page,
        limit: limit,
        status: status,
        contest_type: contest_type,
      };
      
      // Add date filters if provided
      if (fromdate) {
        payload.fromdate = fromdate;
      }
      if (todate) {
        payload.todate = todate;
      }
      
      // Add sorting if provided
      if (sort_type) {
        payload.sort_type = sort_type;
      }
      if (sort) {
        payload.sort = sort;
      }
      
      const response = await storeApis.post(
        CONTEST_LIST_URL,
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          if (
            response.data.message == "Invalid Credentials" ||
            response.data.message == "Unauthenticated" ||
            response.data.message == "Unauthorized"
          ) {
            dispatch({
              type: types.UNAUTHORIZED_CONTEST,
              payload: response.data.statusCode,
            });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        } else {
          dispatch({
            type: types.FETCH_CONTEST_LIST,
            payload: response.data,
          });
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        }
      }
    } catch (err) {
      Toast(err.response?.message || "Failed to fetch contest list", "E");
      dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
      if (err.response?.status === 403) {
        dispatch({
          type: types.UNAUTHORIZED_CONTEST,
          payload: err.response.status,
        });
      }
    }
  };
};

// Fetch Contest by ID
export const fetchContest = (authToken, contestId) => {
  return async (dispatch) => {
    dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: true });
    try {
      const response = await storeApis.post(
        FETCH_CONTEST_URL,
        { contest_id: String(contestId) },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          if (
            response.data.message === "Invalid Credentials" ||
            response.data.message === "Unauthenticated" ||
            response.data.message === "Unauthorized"
          ) {
            dispatch({
              type: types.UNAUTHORIZED_CONTEST,
              payload: response.data.statusCode,
            });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        } else {
          // API response structure: { status: true, message: "...", data: { contest data } }
          // Store only the contest data part
          const contestData = response.data?.data || response.data;
          dispatch({
            type: types.FETCH_CONTEST,
            payload: contestData,
          });
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        }
      }
    } catch (err) {
      Toast(err.response?.data?.message || err.response?.message || "Failed to fetch contest", "E");
      dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
      if (err.response?.status === 403) {
        dispatch({
          type: types.UNAUTHORIZED_CONTEST,
          payload: err.response.status,
        });
      }
    }
  };
};

// Copy Contest
export const copyContest = (authToken, contestId, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: true });
    try {
      const response = await storeApis.post(
        COPY_CONTEST_URL,
        { contest_id: String(contestId) },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          if (
            response.data.message === "Invalid Credentials" ||
            response.data.message === "Unauthenticated" ||
            response.data.message === "Unauthorized"
          ) {
            dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: response.data.statusCode });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        } else {
          Toast(response.data?.message || "Contest copied successfully", "S");
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
          if (typeof onSuccess === "function") onSuccess();
        }
      }
    } catch (err) {
      Toast(err.response?.data?.message || err.response?.message || "Failed to copy contest", "E");
      dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
      if (err.response?.status === 403) {
        dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: err.response.status });
      }
    }
  };
};

// Delete Contest
export const deleteContest = (authToken, contestId, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: true });
    try {
      const response = await storeApis.post(
        DELETE_CONTEST_URL,
        { contest_id: String(contestId) },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          if (
            response.data.message === "Invalid Credentials" ||
            response.data.message === "Unauthenticated" ||
            response.data.message === "Unauthorized"
          ) {
            dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: response.data.statusCode });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        } else {
          Toast(response.data?.message || "Contest deleted successfully", "S");
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
          if (typeof onSuccess === "function") onSuccess();
        }
      }
    } catch (err) {
      Toast(err.response?.data?.message || err.response?.message || "Failed to delete contest", "E");
      dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
      if (err.response?.status === 403) {
        dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: err.response.status });
      }
    }
  };
};

// Pause / Resume Contest
export const pauseContest = (authToken, contestId, isPause, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: true });
    try {
      const response = await storeApis.post(
        PAUSE_CONTEST_URL,
        { contest_id: String(contestId), is_pause: isPause },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          if (
            response.data.message === "Invalid Credentials" ||
            response.data.message === "Unauthenticated" ||
            response.data.message === "Unauthorized"
          ) {
            dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: response.data.statusCode });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        } else {
          Toast(response.data?.message || "Contest status updated successfully", "S");
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
          if (typeof onSuccess === "function") onSuccess();
        }
      }
    } catch (err) {
      Toast(err.response?.data?.message || err.response?.message || "Failed to update contest status", "E");
      dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
      if (err.response?.status === 403) {
        dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: err.response.status });
      }
    }
  };
};

// Create Contest
export const createContest = (authToken, payload, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: true });
    try {
      const response = await storeApis.post(CREATE_CONTEST_URL, payload, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          if (
            response.data.message === "Invalid Credentials" ||
            response.data.message === "Unauthenticated" ||
            response.data.message === "Unauthorized"
          ) {
            dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: response.data.statusCode });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        } else {
          const isSuccess = response.data.status === true;
          if (isSuccess) {
            Toast(response.data?.message || "Contest created successfully", "S");
            if (typeof onSuccess === "function") onSuccess(response.data);
          } else {
            Toast(response.data?.message || "Validation failed", "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        }
      }
    } catch (err) {
      Toast(err.response?.data?.message || err.response?.message || "Failed to create contest", "E");
      dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
      if (err.response?.status === 403) {
        dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: err.response.status });
      }
    }
  };
};

// Update Contest
export const updateContest = (authToken, payload, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: true });
    try {
      const updatePayload = {
        ...payload,
        action: "contest",
      };
      const response = await storeApis.post(UPDATE_CONTEST_URL, updatePayload, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode === "403") {
          if (
            response.data.message === "Invalid Credentials" ||
            response.data.message === "Unauthenticated" ||
            response.data.message === "Unauthorized"
          ) {
            dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: response.data.statusCode });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        } else {
          const isSuccess = response.data.status === true;
          if (isSuccess) {
            Toast(response.data?.message || "Contest updated successfully", "S");
            if (typeof onSuccess === "function") onSuccess(response.data);
          } else {
            Toast(response.data?.message || "Validation failed", "E");
          }
          dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
        }
      }
    } catch (err) {
      Toast(err.response?.data?.message || err.response?.message || "Failed to update contest", "E");
      dispatch({ type: types.CONTEST_TOGGLE_LOADING, payload: false });
      if (err.response?.status === 403) {
        dispatch({ type: types.UNAUTHORIZED_CONTEST, payload: err.response.status });
      }
    }
  };
};
